module.exports = __webpack_public_path__ + "img/icon_footer.349cb7ac.png";